import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: '/videoList',
    name: 'videoList',
    meta:{
      title:"视频专辑"
    },
    component: () => import(/* webpackChunkName: "videoList" */ '../views/videoList')
  },
  {
    path: '/videoDetail',
    name: 'videoDetail',
    meta:{
      title:"视频展示"
    },
    component: () => import(/* webpackChunkName: "videoDetail" */ '../views/videoList/videoDetail.vue')
  },
  {
    path: '/videoAlbum',
    name: 'videoAlbum',
    meta:{
      title:"视频列表"
    },
    component: () => import(/* webpackChunkName: "videoAlbum" */ '../views/videoAlbum')
  },
  {
    path: '/audioAlbum',
    name: 'audioAlbum',
    meta:{
      title:"音频合辑"
    },
    component: () => import(/* webpackChunkName: "audioAlbum" */ '../views/audioAlbum')
  },
  {
    path: '/audioList',
    name: 'audioList',
    meta:{
      title:"音频专辑"
    },
    component: () => import(/* webpackChunkName: "audioList" */ '../views/audioList')
  },
  {
    path: '/audioDetail',
    name: 'audioDetail',
    meta:{
      title:"音频展示"
    },
    component: () => import(/* webpackChunkName: "audioDetail" */ '../views/audioList/audioDetail.vue')
  },
  {
    path: '/galleryImg',
    name: 'galleryImg',
    meta:{
      title:"图片展示"
    },
    component: () => import(/* webpackChunkName: "audioDetail" */ '../views/gallery')
  },
  {
    path: '/gallery',
    name: 'gallery',
    meta:{
      title:"图集"
    },
    component: () => import(/* webpackChunkName: "audioDetail" */ '../views/gallery/galleryDetail.vue')
  },
  {
    path: '/galleryImg2',
    name: 'galleryImg2',
    meta:{
      title:"图片展示"
    },
    component: () => import(/* webpackChunkName: "audioDetail" */ '../views/gallery/index2.vue')
  },
  {
    path: '/bookDetail',
    name: 'bookDetail',
    meta:{
      title: "文档详情",
    },
    component: () => import( '../views/book/index.vue')
  },
  {
    path: '/bookList',
    name: 'bookList',
    meta:{
      title: "文档",
    },
    component: () => import( '../views/book/list.vue')
  }
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


export default router;